export const getAmoungVotes = (players)=>{
    let votes = 0

    players?.forEach(player => {
        votes = votes + player?.votos        
    });
    return votes
}